import { useState } from 'react'
import { WindowFrame } from '@/components/retro/WindowFrame'
import { Header } from '@/components/retro/Header'
import { Sidebar } from '@/components/retro/Sidebar'
import { FooterNav } from '@/components/retro/FooterNav'
import { useIsMobile } from '@/hooks/use-mobile'

import { HomeSection } from '@/components/sections/HomeSection'
import { AboutSection } from '@/components/sections/AboutSection'
import { QuoteSection } from '@/components/sections/QuoteSection'
import { SellSection } from '@/components/sections/SellSection'
import { MaterialsSection } from '@/components/sections/MaterialsSection'
import { LogisticsSection } from '@/components/sections/LogisticsSection'
import { PartnersSection } from '@/components/sections/PartnersSection'
import { ContactSection } from '@/components/sections/ContactSection'

export default function Index() {
  const [activeSection, setActiveSection] = useState('index')
  const isMobile = useIsMobile()

  const handleNavigate = (section: string) => {
    setActiveSection(section)
  }

  const renderContent = () => {
    switch (activeSection) {
      case 'index':
        return <HomeSection onNavigate={handleNavigate} />
      case 'sobre':
        return <AboutSection />
      case 'cotacao':
        return <QuoteSection />
      case 'vender':
        return <SellSection />
      case 'materiais':
        return <MaterialsSection />
      case 'logistica':
        return <LogisticsSection />
      case 'parceiros':
        return <PartnersSection />
      case 'contato':
        return <ContactSection />
      default:
        return <HomeSection onNavigate={handleNavigate} />
    }
  }

  if (isMobile) {
    return (
      <div className="flex flex-col h-screen w-full bg-[#cccccc] font-serif">
        <Header />
        <Sidebar
          activeSection={activeSection}
          onNavigate={handleNavigate}
          isMobile={true}
        />
        <div className="flex-1 overflow-auto bg-white p-4 retro-bevel-inset m-2 rounded-sm shadow-inner relative">
          {renderContent()}
          {/* Online LED for Mobile */}
          <div
            className="absolute bottom-2 right-2 w-2 h-2 bg-green-500 rounded-full border border-green-800 shadow-[0_0_5px_#00ff00] animate-led-pulse"
            title="Online"
          ></div>
        </div>
        <FooterNav activeSection={activeSection} onNavigate={handleNavigate} />
      </div>
    )
  }

  return (
    <WindowFrame className="h-[850px] font-serif bg-retro-gray">
      <Header />
      <div className="flex flex-1 overflow-hidden">
        <Sidebar activeSection={activeSection} onNavigate={handleNavigate} />

        {/* Main Content Area (Viewport) */}
        <div className="flex-1 p-6 flex flex-col bg-[#cccccc]">
          <div className="flex-1 retro-bevel-inset bg-white relative overflow-hidden flex flex-col shadow-inner">
            {/* Content Render */}
            <div className="flex-1 overflow-auto p-1 scroll-smooth">
              {renderContent()}
            </div>

            {/* Online LED */}
            <div
              className="absolute bottom-3 right-3 w-3 h-3 bg-green-500 rounded-full border border-green-800 shadow-[0_0_5px_#00ff00] animate-led-pulse z-20"
              title="System Online"
            ></div>
          </div>
        </div>
      </div>
      <FooterNav activeSection={activeSection} onNavigate={handleNavigate} />
    </WindowFrame>
  )
}
